__webpack_require__.p = "http://shots.slarenasitsolutions.com/";